import { action, observable } from "mobx";
import { FormulaFormVM } from "../template/FormulaFormVM";
import { HydraulicFormulaController } from "cd-eft/services/eftSetApi";
import MessageCenter from "cd-eft/components/common/MessageCenter/MessageCenterVM";
import { PipeDropRequestDto, PipeDropResponseDTO } from "cd-eft/_codegen_/openapi-generator/eft-set";

interface IPipeDropForm {
  earthworksDto: {
    topWidth: string;
    dsToeElev: string;
  }
  commonSideSlopeDto: {
    upStream: string;
    downStream: string;
  }
  commonPipeDto: {
    mannings: string;
    pipeDiameter: string;
    extraPipeBeyondToe: string;
    skewAngle: string;
  }
  pipeDropElevationDto: {
    topElev: string;
    auxSpillwayElev: string;
    waterElev: string;
    riserTopElev: string;
    riserDiameter: string;
    riserLengthBelowInlet: string;
    inletElev: string;
    outletElev: string;
    tailwaterElev: string;
    enableTailwater: boolean;
  }
}
interface IPipeDropResults {
  capacity: string | number;
  lengthOfPipe: string | number;
  riserHeightIncludingSeating: string | number;
  seepagePath: string | number;
  message: string;
}

export class PipeDropVM extends FormulaFormVM {
  readonly formLabelsForExport;
  readonly resultLabelsForExport;
  constructor(props) {
    super(props); //optional
    this.helpLink = 'https://usdagcc.sharepoint.com/:b:/r/sites/FPAC-NRCS-EngineeringPlanningAnalysisandDesignSoftwareEPAD/Shared%20Documents/General/NETS-Support%20Documents/Formulas%20Documentation/Help%20Select%20n%20Value.pdf?csf=1&web=1&e=ssYi6q';
    this.formLabelsForExport = {
      topWidth: 'Top Width (ft)',
      dsToeElev: 'DS Toe Elevation (ft) ',
      upStream: 'Side Slopes Up-stream (ft/ft)',
      downStream: 'Side Slopes Down-stream (ft/ft)',
      mannings: "Manning's n",
      pipeDiameter: 'Pipe Diameter (in)',
      extraPipeBeyondToe: 'Extra Pipe Boyond Toe (ft)',
      skewAngle: 'Skew Angle°',
      topElev: 'Top Elevation (ft)',
      auxSpillwayElev: 'Auxiliary Spillway Elevation (ft)',
      waterElev: 'Water Elevation (ft)',
      riserTopElev: 'Riser-Top Elevation (ft)',
      riserDiameter: 'Riser Diameter (in)',
      riserLengthBelowInlet: 'Riser Length Below Inlet (in)',
      inletElev: 'Inlet Elevation (ft)',
      outletElev: 'Outlet Elevation (ft)',
      tailwaterElev: 'Tailwater Elevation (ft)',
    };

    this.resultLabelsForExport = {
      lengthOfPipe: 'Length of Pipe (ft)',
      seepagePath: 'Seepage Path (ft)',
      capacity: 'Capacity (cfs)',
      riserHeightIncludingSeating: 'Riser Height Including Seating (ft)',
      message: 'Message'
    };
    this.disablePrintBtn = true;
  }
  @observable formValidation = {
    hasError: true,
    topWidth: false,
    dsToeElev: false,
    upStream: false,
    downStream: false,
    mannings: false,
    pipeDiameter: false,
    extraPipeBeyondToe: false,
    skewAngle: false,
    topElev: false,
    auxSpillwayElev: false,
    waterElev: false,
    riserTopElev: false,
    riserDiameter: false,
    riserLengthBelowInlet: false,
    inletElev: false,
    outletElev: false,
    tailwaterElev: false,
    formErrors: {
      topWidth: '',
      dsToeElev: '',
      upStream: '',
      downStream: '',
      mannings: '',
      pipeDiameter: '',
      extraPipeBeyondToe: '',
      skewAngle: '',
      topElev: '',
      auxSpillwayElev: '',
      waterElev: '',
      riserTopElev: '',
      riserDiameter: '',
      riserLengthBelowInlet: '',
      inletElev: '',
      outletElev: '',
      tailwaterElev: '',
    },
  };
  initialCalculationResults: IPipeDropResults = {
    capacity: '',
    lengthOfPipe: '',
    riserHeightIncludingSeating: '',
    seepagePath: '',
    message: ''
  }
  // To properly override the calculationResults property in the StraightDropInletVM class with the specific type IStraightDropResults
  @observable calculationResults: IPipeDropResults = this.initialCalculationResults;
  @observable pipeDropFormInputSnapshot: IPipeDropForm | undefined = undefined;

  @observable pipeDropFormData: IPipeDropForm = {
    earthworksDto: {
      topWidth: "0",
      dsToeElev: "0",
    },
    commonSideSlopeDto: {
      upStream: "0",
      downStream: "0",
    },
    commonPipeDto: {
      mannings: "0",
      pipeDiameter: "0",
      extraPipeBeyondToe: "0",
      skewAngle: "0",
    },
    pipeDropElevationDto: {
      topElev: "0",
      auxSpillwayElev: "0",
      waterElev: "0",
      riserTopElev: "0",
      riserDiameter: "0",
      riserLengthBelowInlet: "0",
      inletElev: "0",
      outletElev: "0",
      tailwaterElev: "0",
      enableTailwater: false
    },
  };

  @action.bound handleOnKeyDown(event) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }


  @action.bound toggleEnableTailwater() {
    this.pipeDropFormData.pipeDropElevationDto.enableTailwater = !this.pipeDropFormData.pipeDropElevationDto.enableTailwater;
    this.formValidation.tailwaterElev = false;
    this.formValidation.formErrors.tailwaterElev = '';
    this.formValidation.hasError = false;
  }

  @action.bound pipeErrorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }
  @action.bound setFixedValue(name, fixed) {
    const event1 = {
     target: {
     name: name,
     value: this.roundingHelperString(fixed, name === "mannings-n"? 4 : 2)
     }
     }
    this.handleInputChange(event1,true);
     }

  // Expand with onChange handlers, onBlur validation, Submit handler, on submit validation, individual variables, etc.
  @action.bound handleInputChange(event, within? :boolean) {
    const { name } = event.target;
    let value = event.target.value
    if (!within && value.length > 7) {
      return;
    }

    switch (name) {
      case 'top-width':
        this.pipeDropFormData.earthworksDto.topWidth = value;
        break;
      case 'ds-toe-elev':
        this.pipeDropFormData.earthworksDto.dsToeElev = value;
        break;
      case 'up-stream':
        this.pipeDropFormData.commonSideSlopeDto.upStream = value;
        break;
      case 'down-stream':
        this.pipeDropFormData.commonSideSlopeDto.downStream = value;
        break;
      case 'mannings-n':
        this.pipeDropFormData.commonPipeDto.mannings = value;
        break;
      case 'pipe-diameter':
        this.pipeDropFormData.commonPipeDto.pipeDiameter = value;
        break;
      case 'extra-pipe-beyond-toe':
        this.pipeDropFormData.commonPipeDto.extraPipeBeyondToe = value;
        break;
      case 'skew-angle':
        this.pipeDropFormData.commonPipeDto.skewAngle = value;
        break;
      case 'top-elev':
        this.pipeDropFormData.pipeDropElevationDto.topElev = value;
        break;
      case 'aux-spillway-elev':
        this.pipeDropFormData.pipeDropElevationDto.auxSpillwayElev = value;
        break;
      case 'water-elev':
        this.pipeDropFormData.pipeDropElevationDto.waterElev = value;
        break;
      case 'riser-top-elev':
        this.pipeDropFormData.pipeDropElevationDto.riserTopElev = value;
        break;
      case 'riser-diameter':
        this.pipeDropFormData.pipeDropElevationDto.riserDiameter = value;
        break;
      case 'riser-length-below-inlet':
        this.pipeDropFormData.pipeDropElevationDto.riserLengthBelowInlet = value;
        break;
      case 'inlet-elev':
        this.pipeDropFormData.pipeDropElevationDto.inletElev = value;
        break;
      case 'outlet-elev':
        this.pipeDropFormData.pipeDropElevationDto.outletElev = value;
        break;
      case 'tailwater-elev':
        this.pipeDropFormData.pipeDropElevationDto.tailwaterElev = value;
        break;
    }
  }

  async validateReqInput() {
    // optional
    await this.validateInput("top-width", this.pipeDropFormData.earthworksDto.topWidth);
    await this.validateInput("ds-toe-elev", this.pipeDropFormData.earthworksDto.dsToeElev);
    await this.validateInput("up-stream", this.pipeDropFormData.commonSideSlopeDto.upStream);
    await this.validateInput("down-stream", this.pipeDropFormData.commonSideSlopeDto.downStream);
    if (this.pipeDropFormData.pipeDropElevationDto.enableTailwater) await this.validateInput("tailwater-elev", this.pipeDropFormData.pipeDropElevationDto.tailwaterElev);
    // required
    await this.validateInput("mannings-n", this.pipeDropFormData.commonPipeDto.mannings);
    await this.validateInput("pipe-diameter", this.pipeDropFormData.commonPipeDto.pipeDiameter);
    await this.validateInput("extra-pipe-beyond-toe", this.pipeDropFormData.commonPipeDto.extraPipeBeyondToe);
    await this.validateInput("skew-angle", this.pipeDropFormData.commonPipeDto.skewAngle);
    await this.validateInput("top-elev", this.pipeDropFormData.pipeDropElevationDto.topElev);
    await this.validateInput("aux-spillway-elev", this.pipeDropFormData.pipeDropElevationDto.auxSpillwayElev);
    await this.validateInput("water-elev", this.pipeDropFormData.pipeDropElevationDto.waterElev);
    await this.validateInput("inlet-elev", this.pipeDropFormData.pipeDropElevationDto.inletElev);
    await this.validateInput("outlet-elev", this.pipeDropFormData.pipeDropElevationDto.outletElev);
    await this.validateInput("riser-top-elev", this.pipeDropFormData.pipeDropElevationDto.riserTopElev);
    await this.validateInput("riser-length-below-inlet", this.pipeDropFormData.pipeDropElevationDto.riserLengthBelowInlet);
    await this.validateInput("riser-diameter", this.pipeDropFormData.pipeDropElevationDto.riserDiameter);
  }
  get validateRequiredInputs() {
    if (!this.formValidation.mannings &&
      !this.formValidation.pipeDiameter && !this.formValidation.topElev &&
      !this.formValidation.extraPipeBeyondToe && !this.formValidation.skewAngle &&
      !this.formValidation.waterElev && !this.formValidation.inletElev &&
      !this.formValidation.outletElev && !this.formValidation.riserTopElev &&
      !this.formValidation.riserLengthBelowInlet && !this.formValidation.riserDiameter
    ) {
      return true
    }
    else {
      return false
    }
  }
  
  @action.bound async validateInput(name, value) {
    let val;
    if (value !== '') {
      if (name === 'mannings-n') {
        val = this.roundingHelperNumber(parseFloat(value), 4)
      }
      else {
        val = this.roundingHelperNumber(parseFloat(value), 2)
      }
      this.setFixedValue(name, val);
    }
    else {
      val = 0;
    }
    switch (name) {
      case 'top-width':
        if (val < 0|| Number.isNaN(value)) {
          this.formValidation.topWidth = true;
          this.formValidation.formErrors.topWidth = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_14', undefined, this.formLabelsForExport.topWidth.replace(/(\s\([\w\W]*\))/, ''))
        }
        else {
          this.formValidation.topWidth = false;
          this.formValidation.formErrors.topWidth = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'ds-toe-elev':
        if (val < 0 || Number.isNaN(value)) {
          this.formValidation.dsToeElev = true;
          this.formValidation.formErrors.dsToeElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_14', undefined, this.formLabelsForExport.dsToeElev.replace(/(\s\([\w\W]*\))/, ''))
        }
        else {
          this.formValidation.dsToeElev = false;
          this.formValidation.formErrors.dsToeElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'up-stream':
        if (val < 0 || Number.isNaN(value)) {
          this.formValidation.upStream = true;
          this.formValidation.formErrors.upStream = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_14', undefined, this.formLabelsForExport.upStream.replace(/(\s\([\w\W]*\))/, ''))
        }
        else {
          this.formValidation.upStream = false;
          this.formValidation.formErrors.upStream = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'down-stream':
        if (val < 0 || Number.isNaN(value)) {
          this.formValidation.downStream = true;
          this.formValidation.formErrors.downStream = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_14', undefined, this.formLabelsForExport.downStream.replace(/(\s\([\w\W]*\))/, ''))
        }
        else {
          this.formValidation.downStream = false;
          this.formValidation.formErrors.downStream = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'mannings-n':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.0001 || val > 1.0) {
          this.formValidation.mannings = true;
          this.formValidation.formErrors.mannings = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_02')
        }
        else {
          this.formValidation.mannings = false;
          this.formValidation.formErrors.mannings = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-diameter':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.02) {
          this.formValidation.pipeDiameter = true;
          this.formValidation.formErrors.pipeDiameter = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_07')
        }
        else {
          this.formValidation.pipeDiameter = false;
          this.formValidation.formErrors.pipeDiameter = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'extra-pipe-beyond-toe':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.extraPipeBeyondToe = true;
          this.formValidation.formErrors.extraPipeBeyondToe = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.extraPipeBeyondToe.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.extraPipeBeyondToe = false;
          this.formValidation.formErrors.extraPipeBeyondToe = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'skew-angle':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.skewAngle = true;
          this.formValidation.formErrors.skewAngle = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.skewAngle.replace(/(\s\([\w\W]*\))|°/, ''));
        }
        else {
          this.formValidation.skewAngle = false;
          this.formValidation.formErrors.skewAngle = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'top-elev':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.topElev = true;
          this.formValidation.formErrors.topElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.topElev.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.topElev = false;
          this.formValidation.formErrors.topElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'aux-spillway-elev':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.auxSpillwayElev = true;
          this.formValidation.formErrors.auxSpillwayElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.auxSpillwayElev.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.auxSpillwayElev = false;
          this.formValidation.formErrors.auxSpillwayElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'water-elev':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.waterElev = true;
          this.formValidation.formErrors.waterElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.waterElev.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.waterElev = false;
          this.formValidation.formErrors.waterElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'riser-top-elev':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.riserTopElev = true;
          this.formValidation.formErrors.riserTopElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.riserTopElev.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.riserTopElev = false;
          this.formValidation.formErrors.riserTopElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'riser-diameter':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.riserDiameter = true;
          this.formValidation.formErrors.riserDiameter = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.riserDiameter.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.riserDiameter = false;
          this.formValidation.formErrors.riserDiameter = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'riser-length-below-inlet':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.riserLengthBelowInlet = true;
          this.formValidation.formErrors.riserLengthBelowInlet = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.riserLengthBelowInlet.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.riserLengthBelowInlet = false;
          this.formValidation.formErrors.riserLengthBelowInlet = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'inlet-elev':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.inletElev = true;
          this.formValidation.formErrors.inletElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.inletElev.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.inletElev = false;
          this.formValidation.formErrors.inletElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'outlet-elev':
        if (value === '' || Number.isNaN(value) || value === 0 || val < 0.01) {
          this.formValidation.outletElev = true;
          this.formValidation.formErrors.outletElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.outletElev.replace(/(\s\([\w\W]*\))/, ''));
        }
        else {
          this.formValidation.outletElev = false;
          this.formValidation.formErrors.outletElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'tailwater-elev':
        if (val < 0) {
          this.formValidation.tailwaterElev = true;
          this.formValidation.formErrors.tailwaterElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_14', undefined, this.formLabelsForExport.tailwaterElev)
        }
        else {
          this.formValidation.tailwaterElev = false;
          this.formValidation.formErrors.tailwaterElev = '';
          this.formValidation.hasError = false;
        }
        break;
    }
  }

  private constructPayload() {
    return {
      earthWorksDto: {
        topWidth: this.pipeDropFormData.earthworksDto.topWidth != null ? parseFloat(this.pipeDropFormData.earthworksDto.topWidth) : 0,
        dsToeElev: this.pipeDropFormData.earthworksDto.dsToeElev ? parseFloat(this.pipeDropFormData.earthworksDto.dsToeElev) : 0,
      },
      commonSideSlopeDto: {
        upStream: this.pipeDropFormData.commonSideSlopeDto.upStream ? parseFloat(this.pipeDropFormData.commonSideSlopeDto.upStream) : 0,
        downStream: this.pipeDropFormData.commonSideSlopeDto.downStream ? parseFloat(this.pipeDropFormData.commonSideSlopeDto.downStream) : 0,
      },
      commonPipeDto: {
        manningsN: parseFloat(this.pipeDropFormData.commonPipeDto.mannings),
        pipeDiameter: parseFloat(this.pipeDropFormData.commonPipeDto.pipeDiameter),
        extraPipeBeyondToe: parseFloat(this.pipeDropFormData.commonPipeDto.extraPipeBeyondToe),
        skewAngle: parseFloat(this.pipeDropFormData.commonPipeDto.skewAngle),
      },
      pipeDropElevationDto: {
        topElev: parseFloat(this.pipeDropFormData.pipeDropElevationDto.topElev),
        auxSpillwayElev: parseFloat(this.pipeDropFormData.pipeDropElevationDto.auxSpillwayElev),
        waterElev: parseFloat(this.pipeDropFormData.pipeDropElevationDto.waterElev),
        riserTopElev: parseFloat(this.pipeDropFormData.pipeDropElevationDto.riserTopElev),
        riserDiameter: parseFloat(this.pipeDropFormData.pipeDropElevationDto.riserDiameter),
        riserLengthBelowInlet: parseFloat(this.pipeDropFormData.pipeDropElevationDto.riserLengthBelowInlet),
        inletElev: parseFloat(this.pipeDropFormData.pipeDropElevationDto.inletElev),
        outletElev: parseFloat(this.pipeDropFormData.pipeDropElevationDto.outletElev),
        tailwaterElev: this.pipeDropFormData.pipeDropElevationDto.tailwaterElev ? parseFloat(this.pipeDropFormData.pipeDropElevationDto.tailwaterElev) : 0,
        enableTailwater: this.pipeDropFormData.pipeDropElevationDto.enableTailwater,
      },
    }
  }

  @action.bound async computefnPipeDrop() {
    this.disablePrintBtn = true;
    this.disableComputeBtn = true;
    this.isLoading = true;
    MessageCenter.blockCalls(['Common_26']);
    await this.validateReqInput();
    if (this.validateRequiredInputs) {
      try {
        const  requestPayload:PipeDropRequestDto = this.constructPayload()
        const response = await HydraulicFormulaController.calculatePipeDropUsingPOST(requestPayload);
        const responsePayload: PipeDropResponseDTO = response.data;
        if (this.hasErrorContent(responsePayload.errorResponse)) {
          MessageCenter.resetMessageCenter()
          MessageCenter.addNotification(responsePayload.errorResponse!.errorMessage!, responsePayload.errorResponse!.errorType!, responsePayload.errorResponse!.errorCode);
          this.hasResults = false;
          this.calculationResults = this.initialCalculationResults;
          this.disablePrintBtn = true;
          this.resetPlotData();
        }
        else if (responsePayload) {
          this.calculationResults = {
            capacity: responsePayload.capacity ? responsePayload.capacity : '',
            lengthOfPipe: responsePayload.pipeLength ? responsePayload.pipeLength : '',
            riserHeightIncludingSeating: responsePayload.riserHeight ? responsePayload.riserHeight : '',
            seepagePath: responsePayload.seepagePath ? responsePayload.seepagePath : '',
            message: responsePayload.message ? responsePayload.message : ''
          }
          this.setPlotData(responsePayload.stageDischargeList!);
          MessageCenter.resetMessageCenter();
          this.pipeDropFormInputSnapshot = JSON.parse(JSON.stringify(this.pipeDropFormData));
          this.hasResults = true;
          this.disablePrintBtn = false;
        }
      }
      catch (error) {
        console.error('Unexpected error in formula calculation. ', error);
      }
      finally {
        this.disableComputeBtn = false;
        this.isLoading = false;
      }
    }
    else {
      this.hasResults = false;
      this.disablePrintBtn = true;
      MessageCenter.resetMessageCenter();
      await MessageCenter.addNotificationFromCode('Common_26');
      this.resetPlotData();
    }
    this.disableComputeBtn = false;
    this.isLoading = false;
    MessageCenter.unblockCalls();
  }

  @action.bound launchAndExport() {
    // disable print button
    this.disablePrintBtn = true;
    this.exportedInputs = [];
    this.exportedResults = [];
    for (const input in this.pipeDropFormInputSnapshot) {
      if (this.pipeDropFormInputSnapshot.hasOwnProperty(input)) {
        const childObj = this.pipeDropFormInputSnapshot[input];
        for (const childProperty in childObj) {
          if (childObj.hasOwnProperty(childProperty)) {
            const label = this.formLabelsForExport[childProperty]
            const value = this.pipeDropFormInputSnapshot[input][childProperty]
            if (label && value !== '') {
              if ((label === 'Tailwater Elevation (ft)' && this.pipeDropFormInputSnapshot.pipeDropElevationDto.enableTailwater === true) || label !== 'Tailwater Elevation (ft)') {
                this.exportedInputs.push({
                  label: this.formLabelsForExport[childProperty],
                  value: this.pipeDropFormInputSnapshot[input][childProperty],
                });
              }
            }
          }
        }
      }
    }
    for (const result in this.calculationResults) {
      if (result !== 'errorResponse' || 'validationPass') {
        const label = this.resultLabelsForExport[result];
        const value = this.calculationResults[result];
        if (label && value !== undefined) {
          this.exportedResults.push({
            label: label,
            value: value
          });
        }
      }
    }
    this.printFormula();
    this.disablePrintBtn = false;
  }

  @action.bound initializeDefaultValues(): void {
    const { pipeDropElevationDto, commonPipeDto, commonSideSlopeDto, earthWorksDto } = this.defaultValues;
    this.pipeDropFormData.earthworksDto = {
      topWidth: this.roundingHelperString(earthWorksDto.topWidth, 2),
      dsToeElev: this.roundingHelperString(earthWorksDto.dsTopElev, 2),
    }
    this.pipeDropFormData.commonSideSlopeDto = {
      upStream: this.roundingHelperString(commonSideSlopeDto.upStream, 2),
      downStream: this.roundingHelperString(commonSideSlopeDto.downStream, 2),
    }
    this.pipeDropFormData.commonPipeDto = {
      mannings: this.roundingHelperString(commonPipeDto.manningsN, 4),
      pipeDiameter: this.roundingHelperString(commonPipeDto.pipeDiameter, 2),
      extraPipeBeyondToe: this.roundingHelperString(commonPipeDto.extraPipeBeyondToe, 2),
      skewAngle: this.roundingHelperString(commonPipeDto.skewAngle, 2),
    }
    this.pipeDropFormData.pipeDropElevationDto = {
      topElev: this.roundingHelperString(pipeDropElevationDto.topElev, 2),
      auxSpillwayElev: this.roundingHelperString(pipeDropElevationDto.auxSpillwayElev, 2),
      waterElev: this.roundingHelperString(pipeDropElevationDto.waterElev, 2),
      riserTopElev: this.roundingHelperString(pipeDropElevationDto.riserTopElev, 2),
      riserDiameter: this.roundingHelperString(pipeDropElevationDto.riserDiameter, 2),
      riserLengthBelowInlet: this.roundingHelperString(pipeDropElevationDto.riserLengthBelowInlet, 2),
      inletElev: this.roundingHelperString(pipeDropElevationDto.inletElev, 2),
      outletElev: this.roundingHelperString(pipeDropElevationDto.outletElev, 2),
      tailwaterElev: this.roundingHelperString(pipeDropElevationDto.tailwaterElev, 2),
      enableTailwater: pipeDropElevationDto.enableTrailwaterelev ? pipeDropElevationDto.enableTrailwaterelev : false,
    }
  }
}